import { createContext, useContext } from 'react';

interface BuildMetadataContextType {
  version: string;
  branch: string;
  environment: string;
}

const BuildMetadataContext = createContext<BuildMetadataContextType | null>(null);

interface BuildMetadataProviderProps {
  version: string;
  branch: string;
  environment: string;
  children: React.ReactNode;
}

function BuildMetadataProvider({ version, branch, environment, children }: BuildMetadataProviderProps) {
  return (
    <BuildMetadataContext.Provider
      value={{
        version,
        branch,
        environment,
      }}
    >
      {children}
    </BuildMetadataContext.Provider>
  );
}

function useBuildMetadata() {
  const context = useContext(BuildMetadataContext);
  if (!context) throw new Error('BuildMetadata context was used outside the BuildMetadata provider.');
  return context;
}

export { BuildMetadataProvider, useBuildMetadata };
